import { formatDate } from "@angular/common";
import { Inject, Injectable, LOCALE_ID } from "@angular/core";
import * as moment from "moment";
import { TramiteDto } from "src/app/listado/listado-tramites-emvs/listado-tramites-emvs.component";
import { EstadoTramiteReturn, TramiteEmvs } from "src/app/listado/listado-tramites-emvs/tramite-emvs";
import { ResponseTramiteElement } from "src/app/model/respuesta_tramite_modelo";

@Injectable({
  providedIn: "root",
})
export class CsvgenerateService {

  constructor(
    @Inject(LOCALE_ID) public locale: string,
  ) { }

  downloadFile(csvData: string, name:string): void {
    let blob = new Blob(["\ufeff" + csvData], {
      type: "text/csv;charset=utf-8;",
    });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", name);
    dwldLink.click();
  }

  cabeceras_tramite: string[] = [
    "id_sede_electronica",
    "fechaAlta_tramite",
    "fechaModificacion_tramite",
    "pdf_tramite",
    "estado_tramite",
  ]
  cabeceras_usuario: string[] = [
    'nombre_usuario',
    'apellido1_usuario',
    'apellido2_usuario',
    'email_usuario',
    'documento_usuario',
  ];
  cabeceras_procedimiento: string[] = [
    'nombre_procedimiento',
    'nombre_departamento'
  ];
  cabeceras_procedimiento1: string[] = [
    'nombre_procedimiento',
    'nombre_departamento'
  ];

  cabeceras_notificacion: string[] = [
    'concepto_remesa',
    'procedimiento_nombre',
    'fecha_creacion',
    'nif',
    'leido',
    'email_titular',
    'tipo_envio',
    'estado'
  ];

  cabeceras_logs: string[] = [
    'origen',
    'logger',
    'threadName',
    'timestamp',
    'maquina',
    'message'
  ];

  generateCsvEmvs  = async (tramites:  any[],  filter: string) => {
    try{
      let csvData = await this.csvmakerTramite(tramites,filter);
      this.downloadFile(csvData,"listado_tramites.csv");
    } catch (error) {       
      
    }

  };

  generateCsvNotificaciones  = async (tramites:  any[],  filter: string) => {
    try{
      let csvData = await this.csvmakerNotificaciones(tramites,filter);
      this.downloadFile(csvData, "listado_notificaciones.csv");
    } catch (error) {       
    }
  };

  generateCsvLogs  = async (tramites:  any[],  filter: string) => {
    console.log(tramites)
    console.log(filter)
    try{
      let csvData = await this.csvmakerLogs(tramites,filter);
      console.log(csvData)
      this.downloadFile(csvData, "listado_logs.csv");
    } catch (error) {  
      console.log(error)     
    }
  };

  formatoFecha(date) {
    if(date){
      let month = (date[1]<10)?'0'+date[1]:date[1];
      let day   = (date[2]<10)?'0'+date[2]:date[2];
      let year  = date[0];
      let hour  = (date[3]<10)?'0'+date[3]:date[3];
      let min   = (date[4]<10)?'0'+date[4]:date[4];
      let seg   = (date[5])?((date[5]<10)?'0'+date[5]:date[5]):'00';
      return [ year, month, day].join('-').concat('T'+[hour, min, seg].join(':') + '.000Z');
    }
    return ''
  }
  filtrar(data: TramiteDto, filter: any): boolean
  {
    let searchString = filter;
    var enRango = true;
    if(searchString.FechaDesde ){
      
      let compareDate = new Date(this.formatoFecha(data['fechaAlta'] ));  
      compareDate.setHours(0, 0, 0, 0);
      let startDate = new Date(searchString.FechaDesde);  
      startDate.setHours(0, 0, 0, 0);
      if(compareDate.getTime() >= startDate.getTime()){
        enRango = true;
      } 
      else{
        enRango = false;
      }
    }
    if(searchString.FechaHasta && enRango){
      let compareDate = new Date(this.formatoFecha(data['fechaAlta'] ));  
      compareDate.setHours(0, 0, 0, 0); 
      let endDate = new Date(searchString.FechaHasta); 
      endDate.setHours(23, 59, 59, 0);
      if(compareDate.getTime() <= endDate.getTime()){
        enRango = true;
      } 
      else{
        enRango = false;
      }
    }
    return enRango
      && (!searchString.DNI || data['usuario_id']?.['numero_documento']?.toString().toLowerCase().trim().indexOf(searchString.DNI?.toLowerCase().trim()) !== -1 )
      && (!searchString.Nombre || data['procedimiento_id']?.['nombre']?.toString().toLowerCase().trim().toLowerCase().indexOf(searchString.Nombre?.toLowerCase().trim())!== -1)        
      && (!searchString.Estado || (data['estadoFirma'] && EstadoTramiteReturn[data['estadoFirma']].indexOf(searchString.Estado)!== -1))
      && (!searchString.PasoTramite || (data['lastVisitedTabLabel'] &&  data['lastVisitedTabLabel']?.toString().toLowerCase().trim().indexOf(searchString.PasoTramite?.toLowerCase().trim()) !== -1 ))
      ;
  }

  private csvmakerNotificaciones = (data:any[],  filter: string) => {
    let csvRows = [];
    let id:number;    
    
    let numHeadersPuestos : number = 0;
      
    let csvHeaders = [];
    let csvBody : string = "";
    const headers = this.cabeceras_notificacion;
    csvHeaders.push(headers.join(';'));
    


    data.forEach(element => {
      if(this.filtrar( element, filter)){
        let csvData = [];
        let csvData2 = [];      


        csvData.push(element.remesa.concepto?? '')
        csvData.push(element.remesa.procedimiento_id?.nombre ??'')
        csvData.push( `${element.fechaCreacion[1]}/${element.fechaCreacion[2]}/${element.fechaCreacion[0]} - ${element.fechaCreacion[3]}:${element.fechaCreacion[4]}`),
        csvData.push(element.nifTitular ?? '')
        csvData.push(element.leido ?? '')
        csvData.push(element.emailTitular?? '')
        csvData.push(element.remesa.tipoEnvio.nombre?? '')
        csvData.push(element.estado ?? '')
        csvData.push(csvData2.join(';'));
        csvBody+=csvData.join(';') + '\n';
     }
    });

    csvRows.push(csvHeaders.join(';'));
    csvRows.push(csvBody.concat(';'));
    return csvRows.join('\n')
  }

  private csvmakerLogs = (data:any[],  filter: string) => {
    let csvRows = [];
    let id:number;    
    
    let numHeadersPuestos : number = 0;
      
    let csvHeaders = [];
    let csvBody : string = "";
    const headers = this.cabeceras_logs;
    csvHeaders.push(headers.join(';'));
    


    data.forEach(element => {
      if(this.filtrar( element, filter)){
        let csvData = [];
        let csvData2 = [];      

        csvData.push(element.origen?? '')
        csvData.push(element.logger ??'')
        csvData.push( element.threadName?? ''),
        csvData.push( moment(element.timestamp).format('DD-MM-YYYY HH:mm')),
        csvData.push(element.maquina?? '')
        csvData.push( element.message.toString().replaceAll(";", ":")?? ''),
        csvData.push(csvData2.join(';'));
        csvBody+=csvData.join(';') + '\n';
     }
    });

    csvRows.push(csvHeaders.join(';'));
    csvRows.push(csvBody.concat(';'));
    return csvRows.join('\n')
  }


  private csvmakerTramite = (data:any[],  filter: string) => {
    let csvRows = [];
    let id:number;    
    
    let numHeadersPuestos : number = 0;
      
    let csvHeaders = [];
    let csvBody : string = "";
    const headers = this.cabeceras_tramite.concat(this.cabeceras_usuario).concat(this.cabeceras_procedimiento);;
    csvHeaders.push(headers.join(';'));
    
    data.forEach(element => {
      if(this.filtrar( element, filter)){
        let csvData = [];
        let csvData2 = [];      
        csvData.push(element.id ?? '')
        csvData.push(element.fechaAlta ? this.formatoFecha(element.fechaAlta) :'')
        csvData.push(element.fechaModificacion ? this.formatoFecha(element.fechaModificacion) :'')
        csvData.push(element.pdfServidor ? element.pdfServidor : element.pdfCliente )
        csvData.push(element.estadoFirma ?? '')
        csvData.push(element.usuario_id.nombre ?? '')
        csvData.push(element.usuario_id.apellido1 ?? '')
        csvData.push(element.usuario_id.apellido2 ?? '')
        csvData.push(element.usuario_id.email ?? '')
        csvData.push(element.usuario_id.numero_documento ?? '')
        csvData.push(element.procedimiento_id.nombre ?? '')
        csvData.push(element.procedimiento_id.departamento.nombre ?? '')
        csvData.push(csvData2.join(';'));
        csvBody+=csvData.join(';') + '\n';
     }
    });

    csvRows.push(csvHeaders.join(';'));
    csvRows.push(csvBody.concat(';'));
    return csvRows.join('\n')
  }
}
